import { MeetingMinutesData } from "./MeetingMinutesForm.schema";
import { OTHER_MATTERS } from "./MeetingMinutesForm.options";

export function restoreMeetingMinutes(
  data: Record<string, unknown>
): MeetingMinutesData {
  const text = (key: string) =>
    typeof data[key] === "string" ? data[key] : "";
  const otherCases = data.dpOtherCases as Record<string, unknown> | undefined;
  const taskNumbers = Array.from(
    new Set(
      Object.keys(data).flatMap((key) => {
        const match =
          /^dpmeet(?:Dotf|DoOwnertf|DoDeadline|DoStatus)([1-9]\d*)$/.exec(key);
        return match ? [Number(match[1])] : [];
      })
    )
  ).sort((a, b) => a - b);

  return {
    docRefMeetPlace: text("docRefMeetPlace"),
    docRefMeetDate: text("docRefMeetDate"),
    docRefMeetPart: text("docRefMeetPart"),
    docRefDet: text("docRefDet"),
    otherCases: Object.fromEntries(
      OTHER_MATTERS.map(({ key }) => [key, otherCases?.[key] === true])
    ) as MeetingMinutesData["otherCases"],
    tasks: (taskNumbers.length ? taskNumbers : [1]).map((n) => ({
      task: text(`dpmeetDotf${n}`),
      owner: text(`dpmeetDoOwnertf${n}`),
      deadline: text(`dpmeetDoDeadline${n}`),
      status: text(`dpmeetDoStatus${n}`),
    })),
  };
}

/**
 * Flatten MeetingMinutesData into the Form.io key naming convention expected
 * by the document producer backend.
 */
export function flattenMeetingMinutes(
  data: MeetingMinutesData
): Record<string, unknown> {
  const flat: Record<string, unknown> = {
    docRefMeetPlace: data.docRefMeetPlace,
    docRefMeetDate: data.docRefMeetDate,
    docRefMeetPart: data.docRefMeetPart,
    docRefDet: data.docRefDet,
    dpOtherCases: data.otherCases,
  };

  data.tasks.forEach((row: MeetingMinutesData["tasks"][number], i: number) => {
    const n = i + 1;
    flat[`dpmeetDotf${n}`] = row.task;
    flat[`dpmeetDoOwnertf${n}`] = row.owner;
    flat[`dpmeetDoDeadline${n}`] = row.deadline;
    flat[`dpmeetDoStatus${n}`] = row.status;
  });

  return flat;
}
